import React from "react";
import "./LegalPages.css";

// Contenu extrait fidèlement de CGU_Paroles_d_Agents.docx (fourni par le SAPPM).
// Ne pas reformuler : toute correction de fond doit venir d'une nouvelle version du document source.
const CGU_TITLE = "CONDITIONS GENERALES D'UTILISATION";
const CGU_SUBTITLE = "Paroles d'Agents - Réseau d'échange, de propositions et d'alertes du SAPPM";
const CGU_INTRO = "Principe directeur. Paroles d'Agents a pour vocation de libérer la parole au travail et d'alimenter le dialogue social. La critique d'une décision, d'une organisation, d'une pratique managériale ou des conditions de travail est légitime. Elle ne peut être modérée du seul fait qu'elle est ferme, dérangeante ou défavorable à l'administration, dès lors qu'elle respecte les personnes et la loi.";

// Version affichée à titre de secours tant que /config n'a pas répondu — la valeur
// affichée provient normalement de CURRENT_CGU_VERSION (ourco-server/config/index.js)
// via la prop cguVersion, seule source de vérité.
const CGU_VERSION_FALLBACK = "0.1";

const CONTENT =     [
        {
            "type": "h2",
            "text": "Préambule"
        },
        {
            "type": "p",
            "text": "Paroles d'Agents est un service porté par le SAPPM afin de permettre aux agents des Services du Premier ministre de partager leur expérience du travail, faire émerger des idées, participer à des sondages, échanger dans des fils de discussion et solliciter, lorsque nécessaire, l'aide d'un représentant du personnel."
        },
        {
            "type": "p",
            "text": "Le service vise à améliorer le dialogue social, la qualité de vie et les conditions de travail, la prévention des difficultés professionnelles et, plus largement, la qualité du service public. Il n'est ni un réseau social généraliste, ni un canal de communication de la hiérarchie, ni un service d'urgence."
        },
        {
            "type": "p",
            "text": "Les présentes conditions générales d'utilisation, ci-après les « CGU », définissent les règles applicables à l'accès et à l'utilisation du service. Elles sont complétées par la page Confidentialité & RGPD et les Mentions légales."
        },
        {
            "type": "h2",
            "text": "Article 1 - Objet et champ d'application"
        },
        {
            "type": "p",
            "text": "Les CGU s'appliquent à toute personne consultant le site public ou utilisant l'espace connecté, notamment les fonctions d'inscription, de profil, d'humeur du jour, de sondage, d'idée, de soutien, de commentaire, de discussion, d'invitation, de signalement et de demande d'aide."
        },
        {
            "type": "p",
            "text": "La consultation des pages publiques n'emporte pas accès aux espaces réservés. Les actualités et les outils publics d'auto-évaluation peuvent être consultés sans compte. Les contributions des agents sont accessibles selon le niveau de visibilité indiqué par le service au moment de leur publication."
        },
        {
            "type": "h2",
            "text": "Article 2 - Accès au service et compte utilisateur"
        },
        {
            "type": "p",
            "text": "L'espace participatif est réservé aux agents disposant d'une adresse professionnelle appartenant à un domaine autorisé. Cette adresse sert à vérifier l'éligibilité au service et à sécuriser l'accès."
        },
        {
            "type": "ul",
            "items": [
                "L'utilisateur fournit des informations exactes lors de l'inscription et maintient ses moyens d'accès à jour.",
                "Le mot de passe est personnel et confidentiel. Il ne doit pas être communiqué à un tiers, y compris à un collègue.",
                "Toute utilisation suspecte ou compromission du compte doit être signalée sans délai au SAPPM.",
                "Un lien d'invitation ne doit être transmis qu'à un collègue susceptible de remplir les conditions d'accès ; il ne doit pas être publié sur un site ou un réseau ouvert au public.",
                "Le SAPPM peut suspendre l'accès lorsque les conditions d'éligibilité ne sont plus remplies, en cas de risque de sécurité ou de manquement grave aux présentes CGU."
            ]
        },
        {
            "type": "p",
            "text": "Un même agent pouvant disposer de plusieurs adresses professionnelles, la gestion de ces situations doit éviter la multiplication artificielle des votes ou des soutiens. Toute tentative de vote multiple ou de contournement des contrôles est interdite."
        },
        {
            "type": "h2",
            "text": "Article 3 - Pseudonymisation, anonymat et confidentialité"
        },
        {
            "type": "p",
            "text": "Dans l'espace participatif, l'utilisateur intervient par défaut sous un pseudonyme composé d'un animal et d'un qualificatif. Lorsque le service propose expressément un mode identifié, l'utilisateur peut choisir de publier sous son identité ; ce choix doit être clair avant validation."
        },
        {
            "type": "p",
            "text": "Important. Un pseudonyme protège l'identité dans l'affichage public ou collectif, mais ne rend pas nécessairement la contribution anonyme au sens technique et juridique : le compte, l'adresse professionnelle et le pseudonyme peuvent rester reliés dans le système. La pseudonymisation ne constitue pas une immunité et n'autorise aucun comportement interdit."
        },
        {
            "type": "p",
            "text": "L'utilisateur s'engage à ne pas chercher à identifier un autre participant, à ne pas révéler son identité réelle, son service précis, ses coordonnées ou tout élément permettant une réidentification, sauf nécessité strictement liée à un signalement légitime dans le canal confidentiel approprié."
        },
        {
            "type": "p",
            "text": "Les fils de discussion ont vocation à être communs aux communautés relevant des Services du Premier ministre : ils ne doivent pas être traités comme des espaces étanches par service. L'utilisateur tient donc compte du fait que ses messages peuvent être lus par des collègues d'autres entités autorisées."
        },
        {
            "type": "p",
            "text": "Les résultats sensibles ou susceptibles de permettre une identification ne sont affichés qu'à partir du seuil de protection défini par le service, actuellement fixé à 15 agents ou participants selon la fonction concernée."
        },
        {
            "type": "h2",
            "text": "Article 4 - Principes de participation"
        },
        {
            "type": "p",
            "text": "Chaque utilisateur contribue de manière libre, sincère et responsable. Le désaccord est normal et utile ; l'attaque personnelle ne l'est pas."
        },
        {
            "type": "ul",
            "items": [
                "Discuter les faits, les idées, les décisions, les méthodes et leurs conséquences, sans dénigrer une personne.",
                "Présenter autant que possible des faits précis, datés et contextualisés ; distinguer ce qui a été personnellement constaté, ce qui a été rapporté et ce qui relève d'une opinion.",
                "Répondre aux arguments sans intimidation, moquerie, humiliation, acharnement ni provocation personnelle.",
                "Préserver la confidentialité des collègues, usagers, partenaires et tiers.",
                "Utiliser les fonctions de soutien, de vote et de signalement de bonne foi, sans coordination artificielle ni manipulation.",
                "Accepter que d'autres agents puissent exprimer une expérience ou une analyse différente."
            ]
        },
        {
            "type": "h2",
            "text": "Article 5 - Contenus et comportements interdits"
        },
        {
            "type": "p",
            "text": "Sont notamment interdits, quels que soient le format ou le niveau de visibilité :"
        },
        {
            "type": "ul",
            "items": [
                "les menaces, appels à la violence, propos haineux, discriminatoires, sexistes, racistes, homophobes, validistes ou visant une personne en raison d'une caractéristique protégée ;",
                "le harcèlement, l'acharnement, l'intimidation, les insultes, l'humiliation ou la mise à l'index d'un participant ;",
                "les accusations présentées comme certaines sans base sérieuse, les propos diffamatoires, les rumeurs malveillantes et les signalements sciemment mensongers ;",
                "la publication de données personnelles d'autrui : nom, photographie, coordonnées, situation médicale ou familiale, horaires, localisation, identifiants, échanges privés ou tout élément permettant une identification non nécessaire ;",
                "la divulgation de documents ou informations couverts par le secret professionnel, la discrétion professionnelle, une classification de sécurité, le secret de l'enquête, le secret médical ou toute autre obligation légale ;",
                "l'usurpation d'identité ou de pseudonyme, l'accès au compte d'autrui, le contournement des règles de sécurité, l'extraction automatisée de données ou toute tentative de perturber le service ;",
                "le spam, la publicité commerciale, le démarchage, les contenus sans rapport avec les objectifs du service ou les campagnes coordonnées destinées à fausser un débat ou un résultat ;",
                "la reproduction d'un contenu protégé sans droit ni autorisation, ainsi que les liens ou fichiers manifestement illicites ou dangereux."
            ]
        },
        {
            "type": "p",
            "text": "Critique autorisée. Le fait de nommer un dysfonctionnement, de contester une réforme, de relater une situation de travail difficile, de demander des comptes ou de soutenir une revendication ne constitue pas en soi un abus. La modération apprécie le contexte, l'intérêt collectif, la bonne foi et la manière dont les faits sont formulés."
        },
        {
            "type": "h2",
            "text": "Article 6 - Règles propres aux services"
        },
        {
            "type": "h3",
            "text": "6.1 Sondages, humeur du jour et résultats"
        },
        {
            "type": "p",
            "text": "Chaque agent répond personnellement et une seule fois lorsqu'une consultation le prévoit. Il est interdit d'organiser des votes multiples, d'utiliser plusieurs comptes ou de faire pression sur d'autres participants. Les résultats sont présentés sous une forme agrégée et demeurent masqués en dessous du seuil de protection applicable."
        },
        {
            "type": "h3",
            "text": "6.2 Idées, soutiens et commentaires"
        },
        {
            "type": "p",
            "text": "Une idée doit être formulée de façon compréhensible, reliée à la vie au travail, au dialogue social ou au service public, et ouverte à la discussion. Le soutien exprime un intérêt ; il ne vaut ni validation juridique, ni engagement de mise en œuvre par le SAPPM ou l'administration. Les commentaires doivent enrichir, questionner ou contester l'idée sans viser personnellement son auteur."
        },
        {
            "type": "h3",
            "text": "6.3 Fils de discussion"
        },
        {
            "type": "p",
            "text": "Les fils sont des espaces de débat entre agents des différentes communautés SPM. L'utilisateur évite les doublons, respecte le thème du fil et ne monopolise pas la discussion par des répétitions, messages en rafale ou interpellations insistantes. Un fil peut être temporairement ralenti ou fermé si les échanges ne permettent plus un débat serein."
        },
        {
            "type": "h3",
            "text": "6.4 Demandes d'aide"
        },
        {
            "type": "p",
            "text": "La demande d'aide est un canal confidentiel et pseudonymisé. Son contenu n'est lisible que par les profils habilités « agent_sappm » et « admin ». Il est destiné à solliciter un représentant du personnel face à une difficulté professionnelle, notamment une situation de conflit, de harcèlement ou de mal-être."
        },
        {
            "type": "p",
            "text": "Ce canal n'est ni un service d'urgence, ni une consultation médicale ou juridique, ni une garantie de prise en charge dans un délai déterminé. En cas de danger immédiat, il convient de contacter les services d'urgence compétents (15 ou 112). En cas de risque suicidaire ou de détresse aiguë, le 3114 est accessible 24 h/24 et 7 j/7."
        },
        {
            "type": "h3",
            "text": "6.5 Outils d'auto-évaluation"
        },
        {
            "type": "p",
            "text": "Les tests QVT, GHQ-12 et parcours d'évaluation proposés sur le site ont une finalité informative. Ils ne posent aucun diagnostic et ne remplacent pas l'avis d'un professionnel de santé ou d'un service compétent."
        },
        {
            "type": "h2",
            "text": "Article 7 - Signalement d'un contenu ou d'un comportement"
        },
        {
            "type": "p",
            "text": "Tout utilisateur peut signaler un contenu qu'il estime contraire aux CGU ou à la loi au moyen de la fonction prévue à cet effet ou par le canal de contact indiqué sur le site."
        },
        {
            "type": "p",
            "text": "Le signalement doit être effectué de bonne foi et comporter, autant que possible, le contenu concerné, sa localisation, le motif du signalement et les éléments de contexte utiles. Signaler un désaccord ne suffit pas : il faut indiquer la règle qui paraît enfreinte ou le risque identifié."
        },
        {
            "type": "p",
            "text": "Le signalement est transmis aux seules personnes habilitées à le traiter. Il ne vaut pas dépôt de plainte et ne remplace pas les dispositifs officiels. En présence d'un contenu susceptible de constituer une infraction ou d'un danger grave, l'utilisateur peut également s'adresser aux autorités compétentes."
        },
        {
            "type": "p",
            "text": "Les signalements abusifs, répétés dans le seul but de faire taire un contradicteur, ou sciemment mensongers peuvent eux-mêmes donner lieu à modération."
        },
        {
            "type": "h2",
            "text": "Article 8 - Modération"
        },
        {
            "type": "p",
            "text": "Le site est modéré par les personnes habilitées par le SAPPM. La modération a pour finalité de préserver la sécurité des participants, la légalité des contenus et la qualité du débat, tout en garantissant la liberté d'expression syndicale et la possibilité d'alerter sur les conditions de travail."
        },
        {
            "type": "h3",
            "text": "8.1 Principes de décision"
        },
        {
            "type": "ul",
            "items": [
                "Impartialité : la règle s'applique de la même manière quelle que soit l'opinion exprimée ou le service concerné.",
                "Proportionnalité : la réponse tient compte de la gravité, du contexte, de la bonne foi, du risque causé et d'éventuelles répétitions.",
                "Traçabilité : les décisions importantes sont motivées et enregistrées dans la mesure nécessaire à leur suivi.",
                "Protection de la parole : aucun contenu n'est retiré uniquement parce qu'il critique l'administration, une orientation, une pratique professionnelle ou une position du SAPPM."
            ]
        },
        {
            "type": "h3",
            "text": "8.2 Mesures possibles"
        },
        {
            "type": "p",
            "text": "Selon la situation, le modérateur peut :"
        },
        {
            "type": "ul",
            "items": [
                "rappeler la règle applicable ou demander à l'auteur de reformuler ;",
                "masquer provisoirement un contenu pendant son examen ;",
                "retirer ou occulter une donnée personnelle ou confidentielle lorsque cela est nécessaire ;",
                "fermer ou ralentir temporairement les commentaires d'un fil ;",
                "retirer un contenu contraire aux CGU ou manifestement illicite ;",
                "adresser un avertissement ;",
                "suspendre temporairement un compte ou, en cas de manquement grave ou répété, supprimer l'accès au service ;",
                "conserver de manière sécurisée les éléments strictement nécessaires à la preuve, à la sécurité du service ou au respect d'une obligation légale ;",
                "signaler les faits aux autorités compétentes lorsque la loi l'impose ou que la gravité de la situation le justifie."
            ]
        },
        {
            "type": "p",
            "text": "En cas de risque immédiat pour une personne, de menace, de divulgation grave de données, d'attaque informatique ou de contenu manifestement illicite, une mesure conservatoire peut être prise sans avertissement préalable."
        },
        {
            "type": "p",
            "text": "Dans la mesure du possible, l'auteur est informé du contenu concerné, de la règle appliquée et de la mesure prise. Il peut demander un réexamen à l'adresse sappm@pm.gouv.fr en précisant le contenu et la décision contestée."
        },
        {
            "type": "h2",
            "text": "Article 9 - Utilisation des contributions par le SAPPM"
        },
        {
            "type": "p",
            "text": "L'utilisateur reste auteur de sa contribution. Il accorde au SAPPM, pour la durée nécessaire au fonctionnement du service, le droit non exclusif de l'héberger, l'afficher, la reproduire techniquement et la modérer afin d'assurer le service."
        },
        {
            "type": "p",
            "text": "Conformément à l'objectif de Paroles d'Agents, le SAPPM peut analyser, synthétiser et présenter aux instances ou interlocuteurs compétents les préoccupations, idées et tendances issues des contributions. Cette réutilisation doit être agrégée ou anonymisée autant que possible et ne doit pas permettre d'identifier l'auteur ou un tiers."
        },
        {
            "type": "p",
            "text": "Une citation littérale ou la transmission d'un élément détaillé susceptible de permettre une réidentification nécessite des précautions particulières et, sauf obligation légale ou nécessité impérieuse de protection, l'accord de la personne concernée."
        },
        {
            "type": "h2",
            "text": "Article 10 - Responsabilité de l'utilisateur"
        },
        {
            "type": "p",
            "text": "L'utilisateur est responsable des contenus qu'il publie et du respect des lois, de ses obligations professionnelles et des présentes CGU. Le pseudonyme ne le dégage pas de cette responsabilité."
        },
        {
            "type": "p",
            "text": "Avant de publier une situation impliquant une personne identifiable, l'utilisateur vérifie que l'information est nécessaire au débat. Lorsqu'une identification est indispensable à la défense de ses droits ou au traitement d'une situation individuelle, il privilégie le canal confidentiel de demande d'aide plutôt qu'un fil collectif."
        },
        {
            "type": "p",
            "text": "Les présentes CGU ne doivent toutefois pas être interprétées comme interdisant un signalement ou une alerte effectués de bonne foi dans les conditions prévues par la loi. En cas de doute sur le canal approprié, l'utilisateur peut solliciter un représentant du personnel."
        },
        {
            "type": "h2",
            "text": "Article 11 - Disponibilité, sécurité et évolution du service"
        },
        {
            "type": "p",
            "text": "Le SAPPM s'efforce d'assurer l'accès et la sécurité du service mais ne garantit pas une disponibilité permanente ni l'absence de toute anomalie. Le service peut être interrompu pour maintenance, sécurité, mise à jour ou cas de force majeure."
        },
        {
            "type": "p",
            "text": "Il est interdit de tester sans autorisation la sécurité du site, d'exploiter une vulnérabilité, d'introduire un code malveillant, d'extraire massivement des données ou de détourner les fonctions du service. Une vulnérabilité constatée doit être signalée discrètement au SAPPM sans en publier les détails."
        },
        {
            "type": "h2",
            "text": "Article 12 - Données personnelles"
        },
        {
            "type": "p",
            "text": "Les traitements de données personnelles, leurs finalités, leurs bases légales, leurs durées de conservation, les destinataires et les droits des personnes sont décrits dans la page Confidentialité & RGPD. En cas de divergence, cette page doit être mise à jour afin de refléter le fonctionnement réel du service."
        },
        {
            "type": "p",
            "text": "Les utilisateurs sont invités à limiter les données personnelles et sensibles qu'ils incluent dans leurs contributions au strict nécessaire. Une contribution pseudonymisée peut néanmoins permettre une réidentification par son contenu ou son contexte."
        },
        {
            "type": "h2",
            "text": "Article 13 - Modification des CGU"
        },
        {
            "type": "p",
            "text": "Le SAPPM peut modifier les CGU pour tenir compte d'une évolution du service, de la réglementation ou des pratiques de modération. La version et sa date d'entrée en vigueur sont indiquées sur le site."
        },
        {
            "type": "p",
            "text": "En cas de modification substantielle, les utilisateurs en sont informés de manière visible et une nouvelle acceptation peut être demandée avant de poursuivre l'utilisation de l'espace connecté."
        },
        {
            "type": "h2",
            "text": "Article 14 - Contact"
        },
        {
            "type": "p",
            "text": "Pour toute question relative aux CGU, à la modération ou à l'exercice d'un droit : sappm@pm.gouv.fr."
        },
        {
            "type": "p",
            "text": "Editeur : SAPPM, 20 avenue de Ségur, 75007 Paris."
        },
        {
            "type": "h2",
            "text": "Charte courte à afficher dans l'application"
        },
        {
            "type": "p",
            "text": "Cette version synthétique peut être affichée près des zones de publication. Elle ne remplace pas les CGU complètes."
        },
        {
            "type": "ol",
            "items": [
                "Je critique les décisions et les pratiques, pas la dignité des personnes.",
                "Je distingue les faits que j'ai constatés, ce qu'on m'a rapporté et mon opinion.",
                "Je n'insulte pas, ne menace pas et ne harcèle personne.",
                "Je ne révèle ni l'identité ni les données personnelles d'un collègue ou d'un tiers.",
                "Je ne publie aucun document ou renseignement couvert par une obligation de secret ou de discrétion.",
                "Pour une situation individuelle sensible, j'utilise la demande d'aide confidentielle.",
                "Je vote, soutiens et signale de bonne foi, sans manipulation ni compte multiple.",
                "Je respecte les opinions différentes et je contribue au thème du fil.",
                "Je sais que mon pseudonyme me protège à l'affichage, mais ne me rend pas irresponsable.",
                "Je peux signaler tout contenu malveillant ; la modération protège le débat et ne censure pas la critique légitime."
            ]
        },
        {
            "type": "h2",
            "text": "Sources officielles consultées"
        },
        {
            "type": "p",
            "text": "Ces sources ont guidé les clauses relatives à la pseudonymisation, aux obligations des agents publics, aux contenus illicites et au signalement. Elles ne remplacent pas une validation juridique individualisée."
        },
        {
            "type": "ul",
            "items": [
                "CNIL - L'anonymisation de données personnelles : https://www.cnil.fr/fr/technologies/lanonymisation-de-donnees-personnelles",
                "CNIL - Minimiser les données collectées : https://www.cnil.fr/fr/minimiser-les-donnees-collectees",
                "Service-Public.fr - Responsabilité des contenus publiés sur internet : https://www.service-public.fr/particuliers/vosdroits/F32075",
                "Service-Public.fr - Comment signaler un contenu illégal publié sur internet : https://www.service-public.fr/particuliers/vosdroits/F31979",
                "Service-Public.fr - Devoirs de réserve, discrétion, neutralité et secret professionnels : https://www.service-public.fr/particuliers/vosdroits/F530",
                "Légifrance - Code général de la fonction publique, article L121-6 : https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000044427903",
                "Légifrance - Code général de la fonction publique, article L121-7 : https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000044427901"
            ]
        }
    ];

function ContentBlock({node, index}) {
    if (node.type === "h2") return <h2 className="legal-section-title">{node.text}</h2>;
    if (node.type === "h3") return <h3 className="legal-section-title" style={{fontSize: "1.05rem", marginTop: 24}}>{node.text}</h3>;
    if (node.type === "p") return <p className="legal-paragraph">{node.text}</p>;
    if (node.type === "ul") {
        return (
            <ul className="legal-list">
                {node.items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
        );
    }
    if (node.type === "ol") {
        return (
            <ol className="legal-list">
                {node.items.map((item, i) => <li key={i}>{item}</li>)}
            </ol>
        );
    }
    return null;
}

export default function CguPage({onBack, cguVersion}) {
    return (
        <div className="legal-page">
            <div className="legal-wrapper">
                {onBack && (
                    <button className="legal-btn-back" onClick={onBack}>← Retour à la page d'accueil</button>
                )}

                <h1 className="legal-title">{CGU_TITLE}</h1>
                <p className="legal-paragraph" style={{fontWeight: 600}}>{CGU_SUBTITLE}</p>

                <div className="legal-version-banner">
                    Version {cguVersion || CGU_VERSION_FALLBACK}
                </div>

                <p className="legal-paragraph">{CGU_INTRO}</p>

                {CONTENT.map((node, i) => <ContentBlock key={i} node={node} index={i} />)}
            </div>
        </div>
    );
}
